<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.3335 13.3334H11.6668V10.0001H17.0868L12.8002 30.0001H8.3335V33.3334H21.6668V30.0001H17.9135L22.2002 10.0001H28.3335V13.3334H31.6668V6.66675H8.3335V13.3334Z" fill="white"/>
  </svg>
</template>
<script>
export default {
  name: 'BxTest'
}
</script>
